<script>

import Swal from "sweetalert2"

export default {
    props: {
        parent: {
            type: Object,
            default: () => {
                return {
                    id: null,
                    parent: null,
                    description: null,
                    children: [],
                }
            }
        },
        consulta: {
            type: Object,
            default: () => {
                return {
                    id: null,
                    descricao: null,
                    consulta: null,
                    parent: null,
                }
            }
        }
    },
    data() {
        return {
            modal: false,
            id: null,
        };
    },
    computed: {
        tags() {
            if (this.consulta.consulta) {
                const matches = this.consulta.consulta.match(/:\w+/g);
                if (!matches) {
                    return [];
                }

                const uniqueTags = Array.from(new Set(matches.map(match => match.slice(1))));
                return uniqueTags;
            }
            return [];
        },
    },
    methods: {
        store() {
            this.consulta.parent = this.parent.id
            this.$axios
                .post(process.env.VUE_APP_API_URL + '/api/master/query_repositories', this.consulta, { headers: this.$headers })
                .then(response => {
                    Swal.fire("Sucesso", "Consulta criada.", "success").then(() => {
                        window.location.reload();
                    })
                    return response
                })
                .catch(error => this.$axiosCatch(error))
                .finally()
        },
        update() {
            this.$axios
                .put(process.env.VUE_APP_API_URL + '/api/master/query_repositories/' + this.id, this.consulta, { headers: this.$headers })
                .then(response => {
                    this.$emit('refresh')
                    Swal.fire("Sucesso", 'Consulta atualizada.', "success").then(() => {
                        window.location.reload();
                    })
                    return response
                })
                .catch(error => this.$axiosCatch(error))
                .finally()
        }
    },
}

</script>
<template>
    <div>
        <b-modal id="modal-lg" size="lg" :title="(id ? 'Editar consulta' : 'Nova consulta')" title-class="font-18"
            hide-footer v-model="modal">
            <b-form @submit.prevent="(id ? update() : store())">

                <div class="row">
                    <div class="col-md-12">
                        <b-form-group class="mb-3" label="ID">
                            <b-form-input type="text" v-model="consulta.id"></b-form-input>
                        </b-form-group>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12">
                        <b-form-group class="mb-3" label="Descrição">
                            <b-form-input type="text" v-model="consulta.descricao"></b-form-input>
                        </b-form-group>
                    </div>
                </div>

                <div class="row">
                    <div class="col-lg-12">
                        <b-form-group class="mb-3" label="Query">
                            <b-form-textarea v-model="consulta.consulta" class="sql-textarea"
                                type="textarea"></b-form-textarea>
                        </b-form-group>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-12">
                        <h5>Filtros da consulta</h5>
                        <ul>
                            <li v-for="tag in tags" :key="tag">{{ tag }}</li>
                        </ul>
                    </div>
                </div>

                <div>
                    <b-button variant="primary" type="submit">Submit</b-button>
                </div>
            </b-form>
        </b-modal>
    </div>
</template>
<style>
.sql-textarea {
    width: 100%;
    height: 200px;
}
</style>